export default __webpack_public_path__ + "static/media/last7.86b615cf.jpg";